import { split } from "lodash";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import { useGetCustomerAttachmentQuery } from "../../utils/customerAttachment.utils";
import { useParams } from "react-router-dom";
import MoneyReceiptAddPage from "../MoneyReceiptAdd";

export default function MoneyReceiptEditPage() {
  const { caid } = useParams();

  const id = caid ? split(caid) : "";

  const { loading, data } = useGetCustomerAttachmentQuery({
    query: `?caid=${caid}`,
    options: {
      enabled: !!caid
    },
    key: `MoneyReceiptEdit-${caid}`
  });

  const title = `${!!id ? "Edit" : "Add"} Money Receipt`;

  const breadCrumbs = [
    {
      name: "Money Receipt List",
      link: "/money-receipt-list"
    },
    {
      name: title
    }
  ];

  const formattedData = data;

  let editItem = formattedData;

  const isLoading = loading;

  return isLoading ? (
    <PageLayout title={title} breadCrumbs={breadCrumbs}>
      <Loading loading={isLoading} />
    </PageLayout>
  ) : (
    <MoneyReceiptAddPage editItem={editItem} />
  );
}
